/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")
  

// 接口文档

  
    
export interface IAPI59650ResDataItem {
  
  /** 用户id */
  userId?: string;
  
  /** 花名 */
  userName?: string;
  
  /** 真实姓名 */
  realName?: string;
  
  /** 头像 */
  headIconUrl?: string;
  
  /** 职位 */
  position?: string;
  
  /** 主部门id */
  orgId?: string;
  
  /** 主部门全路径 */
  orgPathDesc?: string;
  
  /** 手机号 */
  userPhone?: string;
  
};
    
  



export interface API59650Req {
  
  /**  */
  keyword?: string;
    
  /**  */
  userIdList?: string;
    
  /**  */
  isOut?: string;
    
};



export type API59650Res = IAPI59650ResDataItem[];


// 接口函数 59650 通过关键词查询用户

export interface IUseGetAPI59650Return {
  /** 通过关键词查询用户: 接口请求状态 */
  isAPI59650Loading: boolean;
  /** 通过关键词查询用户: 接口请求返回数据 */
  dataAPI59650: API59650Res;
  /**  通过关键词查询用户: 接口数据请求方法 */
  fetchAPI59650Data: (inputs: API59650Req, config?: YWRequestConfig) => Promise<API59650Res>;
  /** 通过关键词查询用户: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI59650 = ():IUseGetAPI59650Return => {
  let isMount = true;
  const [isAPI59650Loading, setIsAPI59650Loading] = useState(false);
  const [dataAPI59650, setDataAPI59650] = useState<API59650Res>({} as API59650Res);
  const requestUrl = `${basePath}/ywwl-admin/selector/listUser`;

  const fetchAPI59650Data = async (inputs: API59650Req, config?: YWRequestConfig): Promise<API59650Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API59650Req>) || {}) as API59650Req;
    
  
    if ( isMount ) {
      setIsAPI59650Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API59650Res>(`${basePath}/ywwl-admin/selector/listUser?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI59650(res || {} as API59650Res);
        setIsAPI59650Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI59650Loading(false);
      }
      return false as unknown as API59650Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI59650Loading,
    dataAPI59650,
    fetchAPI59650Data,
    requestUrl,
  }
}

